var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconLoading = function SvgIconLoading(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 44,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.51 21.772C43.51 33.5 34.01 43 22.282 43 14.332 43 7.4 38.627 3.77 32.163",
    stroke: "#70AED0",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m7.892 32.328-4.463-.483-.456 4.463M1.49 22.228C1.49 10.5 10.99 1 22.718 1c7.95 0 14.88 4.373 18.51 10.837",
    stroke: "#70AED0",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m37.014 11.659 4.463.483.456-4.463",
    stroke: "#70AED0",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })));
};
export default SvgIconLoading;